import { firestore } from "firebase/app";
import "firebase/firestore";

const COLLECTION = "userPurchases";

export default class Purchases {
  userId: string;

  constructor(userId: string) {
    this.userId = userId;
  }

  get doc() {
    return firestore()
      .collection(COLLECTION)
      .doc(this.userId);
  }
}
